<template>
    <section class="featured-stores">
        <div class="container-fluid">
            <h2 class="title-secondary">Lojas em destaque</h2>

            <div class="row">

                <div class="col-12 col-sm-6 col-lg-4">
                    <a href="#" class="card-store">
                        <figure class="image-card">
                            <img src="~@/assets/images/home/featured-stores/store-dne-token.jpg" alt="DNE Token">
                        </figure>

                        <div class="store">
                            <figure class="icon-store icon-green">
                                <img src="~@/assets/images/home/featured-stores/icon-dne-token.svg" alt="DNE Token">
                            </figure>

                            <div class="info-store">
                                <h3>DNE Token</h3>
                                <span>Adquira os seus DNE Token</span>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-12 col-sm-6 col-lg-4">
                    <a href="#" class="card-store">
                        <figure class="image-card">
                            <img src="~@/assets/images/home/featured-stores/store-sport-zone.jpg" alt="Sport Zone">
                        </figure>

                        <div class="store">
                            <figure class="icon-store">
                                <img src="~@/assets/images/home/featured-stores/icon-sport-zone.png" alt="Sport Zone">
                            </figure>

                            <div class="info-store">
                                <h3>Sport Zone</h3>
                                <span>Artigos de desporto</span>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-12 col-sm-6 col-lg-4">
                    <a href="#" class="card-store">
                        <figure class="image-card">
                            <img src="~@/assets/images/home/featured-stores/store-zenith-saude.jpg" alt="Zenith Saúde">
                        </figure>

                        <div class="store">
                            <figure class="icon-store icon-blue">
                                <img src="~@/assets/images/home/featured-stores/icon-zenith-saude.svg" alt="Zenith Saúde">
                            </figure>

                            <div class="info-store">
                                <h3>Zenith Saúde</h3>
                                <span>Experimente a medicina estética</span>
                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    import getMyContentLanguage from "@/services/contentLanguage.js"

    export default {
        data(){
            return {
                flagSelected: "en",
            }
        },

        methods: {
            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code
            },

            getMyLanguage(group, code) {
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code)
            },
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                }
            }
        }
    }
</script>

<style src="@/assets/scss/_card-store.scss" lang="scss" scoped />

<style lang="scss" scoped>
    @import '@/assets/scss/_dneElements.scss';
    // @import '@/assets/scss/_colors.scss';
    
    .featured-stores{
        @include paddingSection;
        background: #eee;
        margin: 0;
        border-bottom: 2px solid #e5e5e5;
    }
</style>